import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PlayIcon = (props: IconProps) => (
  <Icon width="22px" height="28px" viewBox="0 0 22 28" {...props}>
    <path d="M0 0v28l22-14L0 0Z" />
  </Icon>
);

export default memo(PlayIcon);
